"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialPricingZoneUpdateTransport = exports.CommercialPricingZoneCreateTransport = exports.CommercialPricingZoneTransport = exports.CommercialPricingSizeTransport = exports.CommercialPricingQueryParams = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const vehicle_transport_1 = require("../equipment/vehicle/vehicle-transport");
const ca_state_1 = require("./ca-state");
const pricing_transport_1 = require("./pricing-transport");
const us_state_1 = require("./us-state");
exports.CommercialPricingQueryParams = typebox_1.Type.Partial(typebox_1.Type.Object({
    lat: typebox_1.Type.Optional(typebox_1.Type.Number()),
    lng: typebox_1.Type.Optional(typebox_1.Type.Number()),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    active: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
}));
exports.CommercialPricingSizeTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    size: typebox_1.Type.Number({
        minimum: 0,
        maximum: 100,
    }),
    unit: common_1.CapacityUnit,
    truckTypes: typebox_1.Type.Array(vehicle_transport_1.TruckType),
    metadata: common_1.MetaData,
});
exports.CommercialPricingZoneTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    serviceAreas: typebox_1.Type.Array(pricing_transport_1.ServiceAreaTransport),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    sizes: typebox_1.Type.Array(exports.CommercialPricingSizeTransport),
    active: typebox_1.Type.Boolean(),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    type: pricing_transport_1.ZoneType,
    state: typebox_1.Type.Union([us_state_1.UsStateAbbreviation, ca_state_1.CAProvinceAbbreviation]),
    zoneName: typebox_1.Type.Optional(typebox_1.Type.String()),
    deleted: typebox_1.Type.Boolean(),
    materials: typebox_1.Type.Array(common_1.Material),
    metadata: common_1.MetaData,
});
exports.CommercialPricingZoneCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialPricingZoneTransport, ['id', 'sizes', 'active', 'metadata', 'serviceAreas', 'deleted']),
    typebox_1.Type.Object({
        sizes: typebox_1.Type.Array(typebox_1.Type.Object({
            size: typebox_1.Type.Number({
                minimum: 0,
                maximum: 100,
            }),
            unit: common_1.CapacityUnit,
            truckTypes: typebox_1.Type.Array(vehicle_transport_1.TruckType),
        })),
    }),
]);
exports.CommercialPricingZoneUpdateTransport = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialPricingZoneTransport, [
        'id',
        'sizes',
        'metadata',
        'serviceAreas',
        'type',
        'vendorID',
        'vendorName',
        'active',
        'deleted',
    ]),
    typebox_1.Type.Object({
        sizes: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
            size: typebox_1.Type.Number({
                minimum: 0,
                maximum: 100,
            }),
            unit: common_1.CapacityUnit,
            truckTypes: typebox_1.Type.Array(vehicle_transport_1.TruckType),
        }))),
    }),
]));
//# sourceMappingURL=commercial-pricing-transport.js.map